export enum LocalStorage2faKey {
    TimeSinceRequire = 'time_since_require_prompt',
    TimeSincePostPurchase = 'time_since_post_purchase_prompt',
}

export enum PrismTypes {
    key = 'key',
    case = 'case',
}
